module.exports = __webpack_public_path__ + "im-live-list-item-status2-5d5cebf1.png";